import React from 'react'
import './loading-indicator.scss'
import load_simbolo from '../../../assets/icons/load-simbolo-sic.svg'

export default function LoadingIndicator() {
    return (
        <div className="spinner">
            <div class="spinner__asd">
                <div class="spinner__circle">
                    <div class="spinner__orange"></div>
                </div>
            </div>
            <span className="spinner__img">
                <img alt="loading logo" src={load_simbolo}/>
            </span>
        </div>
    )
}
